import React from 'react'
import { getDiscountPoolById } from 'discounts/redux'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { CancelButton } from 'uiComponents/buttons/cancelButton'
import PressAndHoldButton from 'uiComponents/buttons/pressAndHoldButton'
import { Modal, ModalBody, ModalFooter } from 'uiComponents/popups/modal.new'
import { removeHash } from 'utils/hash'
import { useDeleteDiscountPoolMutation } from 'discounts/reduxQuery'
import { useParams } from 'react-router-dom'
import { BaseRouteParams } from 'hocs'
import { addMessage, removeMessage } from 'uiComponents/messages/actions'

interface DeletePoolModalProps {
    poolUuid: string
}

export const DeletePoolModal = ({ poolUuid }: DeletePoolModalProps) => {
    const pool = useAppSelector(getDiscountPoolById(poolUuid))
    const [deletePool] = useDeleteDiscountPoolMutation()
    const dispatch = useAppDispatch()
    const routeParams = useParams<BaseRouteParams>()

    const onConfirm = () => {
        deletePool({ accountSlug: routeParams.accountSlug, uuid: poolUuid })
            .unwrap()
            .then(removeHash)
            .catch(() => {
                const errorVisibleTime = 5000
                dispatch(addMessage('delete_pool_error', 'error', 'Failed to delete pool. Please try again later.'))

                setTimeout(() => {
                    dispatch(removeMessage('delete_pool_error'))
                }, errorVisibleTime)
            })
    }

    return (
        <Modal className="delete-discount-pool-modal" title="Delete pool" onDismiss={removeHash}>
            <ModalBody>
                <p>
                    Are you sure you want to delete pool <strong>{pool?.name}</strong>? This cannot be undone.
                </p>
            </ModalBody>
            <ModalFooter>
                <CancelButton className="back-button" secondary size="large" onClick={removeHash}>
                    Cancel
                </CancelButton>
                <PressAndHoldButton text="Delete" destructive onComplete={onConfirm} />
            </ModalFooter>
        </Modal>
    )
}
